/*
 * @Author: wuxi
 * @Date: 2022-02-17 10:01:38
 * @LastEditors: wuxi
 * @LastEditTime: 2022-02-22 11:33:44
 * @FilePath: \csx-b2b-front-supplier\api\bidManagement.js
 * @Description: 报品报价管理
 */

/**LIST*/
export const API_POST_PRICE_LIST = {
  url: 'api/supplierQuotedPrice/loadPage',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**导出成本价模版*/
export const API_POST_EXPORT_COST_PRICE_TEMPLATE = {
  url: 'api/supplierQuotedPrice/export/costPrice/template',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**导入成本价*/
export const API_POST_IMPORT_COST_PRICE = {
  url: 'api/supplierQuotedPrice/import/costPriceExcel',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**导出到仓价模板*/
export const API_POST_EXPORT_TO_WARE_HOUSE = {
  url: 'api/supplierQuotedPrice/export/toWarehousePrice/template',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**导入到仓价*/
export const API_POST_IMPORT_TO_WARE_HOUSE = {
  url: 'api/supplierQuotedPrice/import/toWarehousePriceExcel',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**发起成本议价导入*/
export const API_POST_BARGAIN_PRICE_IMPORT = {
  url: 'api/supplierBargainingPrice/import/init/cost',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**发起成本议价导出*/
export const API_POST_BARGAIN_PRICE_EXPORT = {
  url: 'api/supplierBargainingPrice/init/cost/export',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**发起到仓议价导入*/
export const API_POST_TO_WARE_BARGAIN_IMPORT = {
  url: 'api/supplierBargainingPrice/import/init/toWarehouse',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**发起到仓议价导出*/
export const API_POST_TO_WARE_BARGAIN_EXPORT = {
  url: 'api/supplierBargainingPrice/initToWarehouse/export',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**成本评议结果导入*/
export const API_POST_COST_RESULT_IMPORT = {
  url: 'api/supplierBargainingPrice/import/costResult',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**成本评议结果导出*/
export const API_POST_COST_RESULT_EXPORT = {
  url: 'api/supplierBargainingPrice/costResult/export',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**到仓评议结果导入*/
export const API_POST_COST_RESULT_TO_WARE_HOUSE_IMPORT = {
  url: 'api/supplierBargainingPrice/import/toWarehouseResult',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**到仓评议结果导出*/
export const API_POST_COST_RESULT_TO_WARE_HOUSE_EXPORT = {
  url: 'api/supplierBargainingPrice/toWarehouseResult/export',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**成本价评议确认*/
export const API_POST_BARGAIN_PRICE_CONFIRM = {
  url: 'api/supplierBargainingPrice/affirm/price',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**获取数量*/
export const API_POST_BARGAIN_COUNT = {
  url: 'api/supplierQuotedPrice/bargainCount',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**弃标*/
export const API_POST_BARGAIN_REJECT_SUCCESS = {
  url: 'api/supplierBargainingPrice/reject/success',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**日最大供货能力配置-新增*/
export const API_POST_CAPACITY_CONFIG_ADD = {
  url: 'supplier/capacity/config/add',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**日最大供货能力配置-编辑*/
export const API_POST_CAPACITY_CONFIG_UPDATE = {
  url: 'supplier/capacity/config/update',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**日最大供货能力配置-删除*/
export const API_POST_CAPACITY_CONFIG_DELETE = {
  url: 'supplier/capacity/config/delete',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**日最大供货能力配置-查询*/
export const API_POST_CAPACITY_CONFIG_PAHE = {
  url: 'supplier/capacity/config/page',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**日最大供货能力配置-查询日志*/
export const API_POST_CAPACITY_CONFIG_LOG_PAHE = {
  url: 'supplier/capacity/config/log/page',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**日最大供货能力配置-导入*/
export const API_POST_CAPACITY_CONFIG_IMPORT = {
  url: 'supplier/capacity/config/import',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**日最大供货能力配置-商品*/
export const API_POST_CAPACITY_PRODUCT_LIST = {
  url: 'public/fast/simple/product/list',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**发货时效配置分页-分页*/
export const API_POST_DELIERYTIME_CONFIG_PAGE = {
  url: 'supplier/deliveryTime/config/page',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};
/**发货时效配置分页-编辑*/
export const API_POST_DELIERYTIME_CONFIG_UPDATE = {
  url: 'supplier/deliveryTime/config/update',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**发货时效配置分页-导入*/
export const API_POST_DELIERYTIME_CONFIG_IMPORT = {
  url: 'supplier/deliveryTime/config/import',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**发货时效配置分页-导出*/
export const API_POST_DELIERYTIME_CONFIG_EXPORT = {
  url: 'supplier/deliveryTime/config/export',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};
